const { resourcePath } = require("./BaseResource");

const basePath = "/admin/booking_confirmations";

export function bookingConfirmationsPath(action, params) {
  return resourcePath(basePath, action, params);
}
